/*
 * A SHARED CLIP'S PAGE STARTS HERE (called from bootstrap.tsx before anything renders; only in a build that has sharing on, on an address /s/<token>). It makes the dashboard believe it is logged in as a stand-in
 * viewer, WITHOUT touching the recipient's real browser state:
 *   - the redux-persist store is PAUSED before the stand-in is put in it, so the stand-in is never written to the browser's storage (a recipient who is also a Skydive customer in this very browser keeps their
 *     own login), and it is put in only once the persisted state has been read, so the real one cannot overwrite it;
 *   - the browser storage the app reads is the page's own memory in a clip's page (util/storage.ts), apart from the one key the dashboard needs (the site id).
 */
import ActionType from "../resources/enums";
import storage from "../util/storage";
import { VIEWER_SITE_ID, viewerUser } from "./viewerServer";

export const bootShareViewer = (store: { dispatch: (action: any) => unknown }, persistor: { pause: () => void; getState: () => { bootstrapped: boolean }; subscribe: (cb: () => void) => () => void }) => {
  persistor.pause();
  try { storage.set("siteId", VIEWER_SITE_ID); } catch { /* the page memory is enough */ }
  const login = () => store.dispatch({ type: ActionType.LOGIN, payload: viewerUser });
  if (persistor.getState().bootstrapped) {
    login();

    return;
  }
  const off = persistor.subscribe(() => {
    if (!persistor.getState().bootstrapped) return;
    off();
    persistor.pause();
    login();
  });
};
